/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc
 */

export const getListingDetailsV1Rpc = {
  serviceName: 'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc',
  rpcName: 'getListingDetailsV1',
  auth: 'app',
  fingerprint: 'r43xwBRJCLJBJlw6H8yN7tntg3zoYxEL',
  na1Only: false,
  isStreaming: false
};